export const lowercase = (value: string): string => {
  if (!value) return ''
  value = value.toString()
  return value.toLowerCase()
}
